import { Platform } from 'react-native';

import type { BiometricType } from './useBiometricCapabilities';

type Translator = (source: string) => string;

// Shared between the enrollment modal and the LoginForm retry button so both
// surfaces refer to the same feature name (e.g. "Face ID" on the modal AND
// "Sign in with Face ID" on the retry button).
//
// Android uses the generic label regardless of `type`: the OS BiometricPrompt
// foregrounds whichever modality (fingerprint / face / iris) it decides on at
// runtime, and "Face ID" is an Apple trademark that shouldn't render on
// Android at all. iOS is deterministic (Face XOR Touch per device) so the
// type-specific labels stay accurate there.
export const featureLabelFor = (t: Translator, type: BiometricType): string => {
  if (Platform.OS === 'android') return t('biometrics');
  if (type === 'face') return t('Face ID');
  if (type === 'fingerprint') return t('fingerprint');
  if (type === 'iris') return t('iris scan');
  return t('biometric sign-in');
};
